<template>
  <section class="interest-point"  v-if="!adding">
    <div class="nav-top">
      <router-link to="/admin/paths" class="arrow-back">
        <img src="@/assets/arrow-orange.svg">
        <p>Voltar</p>
      </router-link>
      <elvas-button :button="{title: 'publicar'}" @click.native="savePath()"></elvas-button>
    </div>
    <div v-if="path">
      <h4 class="admin-medium-bold-text">Percurso</h4>
      <p class="id">ID: {{id}}</p>
      <h5 class="admin-small-bold-text-brown">Imagem</h5>
      <div v-if="$route.params.id !== 'new'">
        <p class="admin-small-text-brown">Imagem de capa do percurso</p>
        <section class="interest-point-images" v-if="image">
          <div class="image">
            <label :for="'image-' + key">
              <img :src="image.image_url">
            </label>
            <input type="file" :id="'image-' + key" hidden @change="e => uploadImage(e, image.description)">
          </div>
        </section>
        <section class="interest-point-images" v-else>
          <div class="image">
            <label for="image-0">
              <elvas-button :button="{title: 'Upload Imagem'}"></elvas-button>
            </label>
            <input type="file" id="image-0" hidden @change="e => uploadImage(e, '0')">
          </div>
        </section>
      </div>
      <div v-else>
        <p class="admin-small-text-brown">Imagens apenas podem ser adicionadas depois de criado o percurso.</p>
      </div>
      <section class="data">
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Nome</p>
            <div><input placeholder="Nome em Português (PT)" v-model="translations.find(t => t.language === 'pt').title"></div>
            <div class="div-input-margin"><input placeholder="Nome em Inglês (EN)" v-model="translations.find(t => t.language === 'en').title"></div>
            <div class="div-input-margin"><input placeholder="Nome em Espanhol (ES)" v-model="translations.find(t => t.language === 'es').title"></div>
          </div>
          <div>
            <p class="admin-small-bold-text-brown">Tipologia</p>
            <select v-model="path.type">
              <option value="" disabled selected>Tipologia</option>
              <option value="onde_dormir">Onde Dormir</option>
              <option value="o_que_visitar">O que Visitar</option>
              <option value="onde_comer">Onde Comer</option>
              <option value="onde_comprar">Onde Comprar</option>
            </select>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Descrição</p>
            <div><textarea placeholder="Descrição em Português (PT)" v-model="translations.find(t => t.language === 'pt').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Inglês (EN)" v-model="translations.find(t => t.language === 'pt').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Espanhol (ES)" v-model="translations.find(t => t.language === 'pt').description"></textarea></div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Selecionar pontos de interesse</p>
            <section class="interest-point-items">
              <article class="interest-point-item" v-for="(interestPoint) in interestPoints" :key="interestPoint.id">
                <img class="image" v-if="interestPoint.images && interestPoint.images[0]" :src="interestPoint.images[0].image_url">
                <h6 class="admin-medium-bold-text-brown">{{interestPoint.translation && interestPoint.translation.title}}</h6>
                <p class="admin-small-text-brown">{{interestPoint.type}}</p>
              </article>
            </section>
            <div class="add-interest-point" @click="adding = true">
              <p>Adicionar pontos de interesse</p>
            </div>
          </div>
        </section>
      </section>
    </div>
  </section>
  <section v-else class="add-interest-points-container">
    <nav>
      <h4>Lista de pontos de interesse</h4>
      <img src="@/assets/close.svg" @click="adding = false">
    </nav>
    <div v-if="allInterestPoints" class="interest-point">
      <section class="add-interest-points">
        <article v-for="(interestPoint) in allInterestPoints" :key="interestPoint.id + new Date()">
          <img class="image" v-if="interestPoint.images && interestPoint.images[0]" :src="interestPoint.images[0].image_url">
          <div class="added" v-if="interestPointAdded(interestPoint.id)">Added</div>
          <div class="remove-icon" v-if="interestPointAdded(interestPoint.id)" @click="removeInterestPoint(interestPoint)">
            <img src="@/assets/close.svg">
          </div>
          <div v-else class="add-icon" @click="addInterestPoint(interestPoint)">
            <img src="@/assets/add-icon.svg">
          </div>
          <h6 class="admin-medium-bold-text-brown">{{interestPoint.translation && interestPoint.translation.title}}</h6>
          <p class="admin-small-text-brown">{{interestPoint.type}}</p>
        </article>
      </section>
    </div>
    <elvas-button class="delete-button" v-if="path && $route.params.id !== 'new'" :button="{title: 'eliminar'}" @click.native="deletePath()"></elvas-button>
  </section>
</template>
<script>

export default {
  name: 'adminPaths',
  components: {
  },
  props: ['id'],
  data() {
    return {
      path: null,
      interestPoints: null,
      allInterestPoints: null,
      adding: false,
      translations: [
        {
          language: 'pt'
        },
        {
          language: 'en'
        },
        {
          language: 'es'
        }
      ],
      image: null
    }
  },
  async mounted () {
    if (this.$route.params.id !== 'new') {
      this.path = await this.api.get('path/' + this.$route.params.id)
      this.image = this.path.images[0]
      this.interestPoints = await this.api.get('interestPoint?path=' + this.$route.params.id )
      this.translations.forEach(t => {
        let pathTranslation = this.path.translations.find(it => it.language === t.language)
        if (pathTranslation) {
          t.title = pathTranslation.title
          t.description = pathTranslation.description
          t.type = pathTranslation.type
          t.exists = true
        }
      })
    } else {
      this.path = {}
    }
    
  },
  methods: {
    async getInterestPoints () {
      this.allInterestPoints = await this.api.get('interestPoint')
    },
    interestPointAdded (pointId) {
      let found = this.interestPoints.find(i => i.id === pointId)
      return found
    },
    async addInterestPoint (interestPoint) {
      let response = await this.api.post('/path/' + this.path.id + '/add/interestPoint/' + interestPoint.id)
      this.interestPoints.push(interestPoint)
    },
    async removeInterestPoint (interestPoint) {
      let response = await this.api.post('/path/' + this.path.id + '/remove/interestPoint/' + interestPoint.id)

      let found = this.interestPoints.find(i => i.id === interestPoint.id)
      let index = this.interestPoints.indexOf(found)

      this.interestPoints.splice(index, 1)

      this.selectedInterestPoints.push(interestPoint.id)

      this.interestPoints = [...this.interestPoints]
    },
    async savePath () {
      let response
      if (this.$route.params.id !== 'new') {
        // response = await this.api.put('/path/' + this.path.id, this.path)
      } else {
        response = await this.api.post('/path', this.path)
        this.path = response.data
      }
      this.translations.forEach(async t => {
        if (t.exists) {
          await this.savePathTranslation(t)
        } else {
          await this.addPathTranslation(t)
        }
      })

    },
    async savePathTranslation (pathTranslation) {
      let response = await this.api.put('/pathTranslation/' + this.path.id + '/language/' + pathTranslation.language, pathTranslation) 

    },
    async addPathTranslation (pathTranslation) {
      let response = await this.api.post('/pathTranslation', {...pathTranslation, path_id: this.path.id})
      pathTranslation.exists = true

    },
    async uploadImage (e, description) {
      let data = new FormData()
      data.append('image', e.target.files[0])
      data.append('content_id', this.path.id)
      data.append('description', description)

      let response = await this.api.post('/image', data)
      this.image = response.data
    },
    async deletePath () {
      await this.api.delete('/path/' + this.interestPoint.id)
      this.$router.push('..')
    }
  },
  watch: {
    adding (to, from) {
      if (to && !from) {
        this.getInterestPoints()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.interest-point {
  width: calc(100% - 256px);
  padding: 16px 128px 100px 128px;
  flex-grow: 1;
  background: #fff;

  @media (max-width: 1000px){
    padding: 16px 56px 100px 56px;
    width: calc(100% - 300px);
  }

  @media (max-width: 550px){
    padding: 16px 12px 100px 12px;
    width: calc(100% - 100px);
  }
}
.nav-top {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  .elvas-button {
    margin-left: auto;

    @media (max-width: 550px){
      padding: 16px 28px;
    }
  }
}
.arrow-back {
  display: flex;
  align-items: center;
  img {
    transform: rotateY(180deg);
  }
  p {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    color: #f6b92f;
    text-transform: uppercase;
  }

  @media (max-width: 550px){
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.interest-point-images {
  display: flex;
  width: 100%;
  margin-top: 16px;
  .image {
    width: calc(100% / 3 - 20px);
    img {
      width: 100%;
    }
    &:nth-of-type(2) {
      margin: 0 30px;
    }
  }

  @media (max-width: 1000px){
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    .image {
      width: 100%;

      &:nth-of-type(2) {
        margin: 0;
      }
    }
  }

  @media (max-width: 700px){
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    .image {
      width: 100%
    }
  }
}
input, textarea,select {
  padding: 12px 16px;
  border: 1px solid#f6ede0;
  width: calc(100% - 32px);
  &:active, &:focus {
    outline: 1px solid #f6b92f;
  }
}
textarea {
  min-height: 88px;
}
select {
  margin-top: 16px;

  @media (max-width: 800px){
    width: 100%;
  }
}
h4 {
  margin-bottom: 5px;
}
h5 {
  margin-bottom: 10px;
}
.id {
  margin-bottom: 32px;
}
.admin-small-bold-text-brown {
  margin-bottom: 16px;
}
.base-interest-point-information, .translation-interior {
  margin-left: 20px;
  margin-right: 60px;
  & > section {
    display: flex;
    width: 100%;
    & > div {
      margin-right: 40px;
      flex-grow: 1;
      margin-bottom: 10px;
      input, textarea {
        width: 100%;
        padding: 5px;
        margin: 5px 0 20px 0;
      }
      textarea {
        min-height: 60px;
        margin: 25px 0 20px 0;
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
}
.data {
  section {
    width: 100%;
    display: flex;
    margin-top: 32px;
    div {
      flex-grow: 1;
    }
    & > div:nth-of-type(2) {
      padding-left: 30px;
    }
  }

  @media (max-width: 800px){
    section {
      flex-direction: column;

      & > div:nth-of-type(2) {
        padding-left: 0;
        margin-top: 32px;
      }
    }
  }
}
.div-input-margin {
  margin-top: 16px;
}
.translations {
  h5 {
    margin-left: 20px;
  }
  .translation-container, .new-translation-container {
    .language {
      display: flex;
      margin: 10px 0;
      margin-left: 20px;
      .language-name {
        margin-left: 10px;
        font-weight: bold;
      }
      select {
        margin-left: 10px;
      }
    }
  }
  .translation-container {
    margin-left: 20px;
  }
}
.add-interest-point {
  height: 200px;
  width: 300px;
  display: flex;
  align-items: center;
  background: #f6ede0;
  p {
    font-weight: bold;
    margin: 0 auto;
    padding: 20px;
  }

  @media (max-width: 650px){
    width: 100%;
    p {
      padding: 20px 8px;
    }
  }
}
.add-interest-points-container {
  width: 100%;
  nav {
    background: #a79374;
    padding: 24px 128px;
    display: flex;
    img {
      margin-left: auto;
      cursor: pointer;
    }
    h4 {
      font-size: 24px;
      font-weight: bold;
      letter-spacing: -0.55px;
      color: #ffffff;
    }
  }
}
.add-interest-points {
  display: flex;
  flex-wrap: wrap;
  article {
    position: relative;
    width: calc(100% / 3 - 20px);
    margin-top: 20px;
    margin-bottom: 20px;
    &:nth-of-type(3n + 2) {
      margin-left: 30px;
      margin-right: 30px;
    }
    img {
      width: 100%;
    }
    h6 {
      margin-top: 16px;
    }
    .added {
      position: absolute;
      padding: 8px 16px 8px 16px;
      border-radius: 20px;
      background-color: #a79374;
      top: 16px;
      left: 16px;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
    .remove-icon, .add-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      border-radius: 50%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin: 0 auto;
      }
    }
    .remove-icon {
      background: #f6b92f;
    }
    .add-icon {
      background: #fff;
    }
  }
}
.interest-point-items {
  position: relative;
  margin-bottom: 40px;
  flex-wrap: wrap;
  .interest-point-item {
    width: calc(100% / 3 - 20px);
    position: relative;
    &:nth-of-type(3n + 2) {
      margin-left: 30px;
      margin-right: 30px;
    }
    .image {
      width: 100%;
    }
  }

  @media (max-width: 900px){
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    .interest-point-item {
      width: 100%;

      &:nth-of-type(3n + 2) { 
        margin: 0;
      }
    }
  }

  @media (max-width: 600px){
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>